import {
  FaIcon,
  faUserCheckSolid,
  faUserDashedSolid,
  faUsersSolid,
  faUsers,
} from '@/lib/fa'
import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

import * as React from 'react'

const GroupsStage = () => {
  const { t } = useLocalize()
  const {
    data,
    isActive,
    groups,
    setIsOpenAddDriverModal,
    isEditState,
    selectedGroups,
  } = useDriverForm()

  return (
    <>
      {selectedGroups.length > 0 && (
        <div className="tw-flex tw-flex-col tw-gap-4">
          <p className="tw-m-0 tw-text-sm">{t('driverBasics.driver-added-to-groups')}</p>
          <div className="tw-flex tw-items-center tw-gap-5">
            {isActive ? (
              <div className="tw-flex tw-items-center tw-gap-2">
                <FaIcon icon={faUserCheckSolid} className="tw-text-content-base" />
                <p className="tw-m-0 tw-text-xs tw-font-medium tw-text-content-base/90">
                  {t('driverBasics.active-plural')}
                </p>
              </div>
            ) : (
              <div className="tw-flex tw-items-center tw-gap-2">
                <FaIcon icon={faUserDashedSolid} className="tw-text-content-base" />
                <p className="tw-m-0 tw-text-xs tw-font-medium tw-text-content-base/90">
                  {t('driverBasics.inactive-plural')}
                </p>
              </div>
            )}

            {selectedGroups.map(group => (
              <div key={group.id} className="tw-flex tw-items-center tw-gap-2">
                <FaIcon icon={faUsersSolid} className="tw-text-content-base" />
                <p className="tw-m-0 tw-text-xs tw-font-medium tw-text-content-base/90">
                  {group.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      <div
        className="tw-flex tw-items-center tw-gap-2"
        onClick={() => setIsOpenAddDriverModal(true)}
      >
        <p className="tw-m-0 tw-cursor-pointer tw-text-sm tw-font-normal tw-text-primary tw-underline">
          {selectedGroups.length > 0
            ? t('driverBasics.edit-groups')
            : t('driverBasics.add-driver-to-group')}
        </p>
        <FaIcon icon={faUsers} className="tw-text-primary" />
      </div>
    </>
  )
}

export default GroupsStage
